import { z } from "zod";
/** Chapters that currently ship a civic still-life. Others stay paper until Vertex fills them. */
export const NCM_CHAPTER_STILL_LIFE_CODES = ["16", "17", "20", "21", "22", "26", "27"];
/**
 * Civic still-life for an SH chapter. This illustrates the classification
 * bucket. It is not an official photo, a product SKU, or a published rate.
 */
export const ncmChapterIllustrationStatusSchema = z.enum(["READY", "PENDING", "PAPER"]);
export const ncmChapterIllustrationSourceSchema = z.enum(["VERTEX", "STATIC", "PAPER"]);
export const ncmChapterIllustrationSchema = z
    .object({
    chapter: z.string().regex(/^\d{2}$/),
    status: ncmChapterIllustrationStatusSchema,
    imageUrl: z.string().min(1),
    source: ncmChapterIllustrationSourceSchema,
    provider: z.string().min(1).nullable(),
    model: z.string().min(1).nullable(),
})
    .strict();
//# sourceMappingURL=ncm-illustration.js.map